import { render, staticRenderFns } from "./fkdform.vue?vue&type=template&id=05ea992f&scoped=true&"
import script from "./fkdform.vue?vue&type=script&lang=js&"
export * from "./fkdform.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "05ea992f",
  null
  
)

export default component.exports